export const brand = {
  name: 'EZ AP',
  logoUrl: '/logo.svg',
  colors: {
    primary: '#4338ca',
    secondary: '#52525b',
    accent: '#6366f1',
  },
} as const;
